// Email/phone validation shared between the GI gister personal-information
// form and the wizard send handler. Kept dependency-free so importing it
// from the flow code does not drag the whole form into the bundle.

// Stricter email: trimmed, no leading/trailing/consecutive dots on the local
// part, and the final TLD must be at least 2 characters.
const EMAIL_RE = /^[A-Za-z0-9_+](?:[A-Za-z0-9._+'-]*[A-Za-z0-9_+-])?@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;
export const isValidEmail = (email) => {
  if (!email) return false;
  const trimmed = email.trim();
  if (trimmed.length > 254) return false;
  if (!EMAIL_RE.test(trimmed)) return false;
  // Reject consecutive dots in the local part and right before '@'
  const local = trimmed.slice(0, trimmed.lastIndexOf('@'));
  if (local.includes('..')) return false;
  return true;
};

// National significant number lengths (digits after the country code) for each
// country offered in the dropdown. The server prepends `phoneCode` itself.
const PHONE_RULES = {
  "+1":   { min: 10, max: 10 }, // US / Canada
  "+57":  { min: 10, max: 10 }, // Colombia
  "+91":  { min: 10, max: 10 }, // India
  "+49":  { min: 5,  max: 11 }, // Germany (variable)
  "+972": { min: 9,  max: 9 },  // Israel
  "+44":  { min: 9,  max: 10 }, // United Kingdom
  "+33":  { min: 9,  max: 9 },  // France
  "+389": { min: 8,  max: 8 },  // North Macedonia
};

export const isValidPhone = (phone, countryCode) => {
  if (!phone || !phone.trim()) return false;
  const trimmed = phone.trim();
  // Only digits, spaces, dashes, parens, and a single optional leading '+'
  if (!/^\+?[\d\s\-()]+$/.test(trimmed)) return false;

  let digits = trimmed.replace(/\D/g, '');
  const hadPlus = trimmed.startsWith('+');

  // Convert international dialing prefix "00" to "+"
  if (!hadPlus && digits.startsWith('00')) digits = digits.slice(2);

  // If the user typed a full international number, accept it as long as the
  // digit count is plausible (7-15, per E.164) and it matches the selected
  // country's code if that code is present in the input.
  const codeDigits = (countryCode || '').replace(/\D/g, '');
  const startsWithCountryCode = codeDigits && digits.startsWith(codeDigits);

  if (hadPlus || trimmed.startsWith('00')) {
    if (startsWithCountryCode) {
      const national = digits.slice(codeDigits.length);
      const rules = PHONE_RULES[countryCode];
      return rules ? national.length >= rules.min && national.length <= rules.max
                   : digits.length >= 7 && digits.length <= 15;
    }
    return digits.length >= 7 && digits.length <= 15;
  }

  // National number only: strip one leading trunk zero (e.g. Israeli mobile "052...")
  if (digits.startsWith('0')) digits = digits.slice(1);

  const rules = PHONE_RULES[countryCode];
  if (!rules) return false;
  return digits.length >= rules.min && digits.length <= rules.max;
};
